import { State } from '../state';
import { DefaultApi, Configuration } from '../../userApi';
import { safeJsonFetch } from '../../utils/safeFetch';

const defaultBasePath = () => {
  const configuredApi = process.env.REACT_APP_API_URL;
  if (configuredApi) {
    return `${configuredApi.replace(/\/+$/, '')}/v1`;
  }
  switch (true) {
    case window.location.hostname.search('nginx') >= 0:
    case window.location.hostname.search('localhost') >= 0:
    case window.location.hostname.search('127.0.0.1') >= 0:
      return `${process.env.REACT_APP_API_URL}/v1`;
    default:
      return `${window.location.protocol}//${window.location.host}/v1`;
  }
};

export const userApiBasePath = (state: State) =>
  state.initialQuery.userApiBase || defaultBasePath();

export const userApi = (state: State) => {
  const basePath = userApiBasePath(state);
  const configuration = new Configuration({
    apiKey: state.token,
    basePath
  });
  return new DefaultApi(configuration, basePath, safeJsonFetch);
};
